import React from "react";

export default function Modal(props) {
  if (!props.show) {
    return null;
  }

  return (
    <div
      className="z-10 fixed bg-opacity-50 bg-black w-full mb-10"
      onClick={(e) => {
        if (!e.defaultPrevented) {
          (props.onClose || (() => {}))(e);
        }
      }}
    >
      <div
        className="absolute font-semibold top-8 right-8 cursor-pointer z-50 underline"
        onClick={props.onClose || (() => {})}
      >
        Close
      </div>
      <div className="cursor-pointer z-20 h-screen relative w-full p-5 pb-10 overflow-y-scroll">
        <div
          className="cursor-auto p-3 mb-20 bg-white"
          onClick={(e) => {
            if (!e.defaultPrevented) {
              return e.preventDefault();
            }
          }}
        >
          {props.children}
        </div>
      </div>
    </div>
  );
}
